import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a missing icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <MissingIcon width={12} />
 */
const MissingIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M25.325
            8.467c-0.423-0.72-0.907-1.379-1.371-2.057-1.591-1.467-3.187-2.928-5.659-3.515h-2.057c-1.469
            0.417-2.686 1.087-4.115 1.543-0.279 0.351-0.785 0.474-1.029 0.857-0.349 0.308-0.704 0.61-1.029
            0.943-0.373 0.027-0.542 0.258-0.857 0.343-0.706 0.752-1.411 1.504-1.714 2.657 0.061
            0.263-0.089 0.313-0.087 0.515 0.123 0.363 0.035 0.937 0.172 1.286 0.039 0.393-0.37
            0.661-0.085 1.029 0.346 0.425 1.339 0.203 2.057 0.257 0.741 0.146 1.606 0.166 2.401
            0.257 0.229-0.114 0.113-0.573 0.257-0.772 0.023-0.349 0.161-0.582 0.258-0.857 0.198-0.487
            0.679-0.693 0.943-1.114 0.43-0.256 0.698-0.674 1.2-0.858 0.895-0.415 2.115-0.493
            3.257-0.257 0.301 0.272 0.72 0.424 0.858 0.857-0.028 1.042 0.152 1.372-0.086 2.229-0.066
            0.018-0.099 0.072-0.085 0.171-0.548 0.624-1.339 1.005-1.972 1.543-0.742 0.458-1.403
            0.998-2.144 1.458-0.78 0.819-1.599 1.601-1.886 2.914-0.134 0.667-0.22 1.381-0.257
            2.143 0.066 0.764-0.187 1.844 0.257 2.229 0.135 0.22 0.791 0.24 1.029 0.086 0.191
            0.266 0.634 0.281 1.114 0.257 0.319 0.139 0.844 0.071 1.286 0.086 0.456-0.001 0.969
            0.054 1.2-0.171 0.254-0.262 0.155-0.874 0.172-1.372 0.405-0.538 0.804-1.082 1.201-1.629
            0.658-0.513 1.251-1.091 1.972-1.543 0.61-0.562 1.209-1.134 1.886-1.629 0.647-0.525
            1.153-1.191 1.8-1.715 0.191-0.381 0.539-0.606 0.686-1.029 0.346-0.254 0.426-0.775
            0.686-1.114 0.205-1.353 0.046-2.917-0.257-4.029zM13.922 19.955c-0.044-0.044 0.062-0.109
            0.086-0.085 0.044 0.044-0.062 0.109-0.086 0.085zM23.954 12.068c-0.878 1.608-2.25
            2.724-3.601 3.858-1.263 1.195-2.802 2.115-3.687 3.686h-0.428c-0.271 0.185-0.498
            0.417-0.6 0.772-0.265 0.193-0.080 0.834-0.515 0.858-0.359 0.031-0.061-0.28-0.086-0.429-0.001-0.202
            0.148-0.252 0.086-0.515 0.172-0.256 0.253-0.605 0.257-1.028-0.123-0.251-0.389-0.41-0.686-0.258
            0.221-0.551 0.632-0.912 0.943-1.372 0.325-0.276 0.913-0.287 0.943-0.857
            0.074-0.275-0.222-0.178-0.257-0.343-0.298-0.069-0.329 0.127-0.601 0.085-0.238
            0.099-0.413 0.211-0.6 0.342-0.168 0.118-0.279 0.32-0.514 0.343 0.661-1.053
            1.842-1.587 2.829-2.314 0.685-0.572 1.31-1.204 1.972-1.8 0.167-0.433 0.477-0.723
            0.685-1.115-0.004-0.404 0.15-0.65 0.172-1.029 0.194-0.177 0.305-0.439
            0.428-0.686-0.148-1.023-0.556-1.787-1.2-2.315-0.062-0.262 0.148-0.251
            0.085-0.514-0.302-0.269-0.672-0.47-1.029-0.686-0.15 0.078-0.157 0.301-0.257
            0.429-0.24-0.046-0.445-0.127-0.685-0.171h-1.029c-0.289 0.14-0.865-0.007-1.113
            0.171-0.259-0.119 0.177-0.444-0.087-0.601-0.264 0.106-0.459 0.283-0.599
            0.514-0.198 0.174-0.436 0.307-0.6 0.514-0.221-0.007-0.090-0.367-0.429-0.257-0.362
            0.066-0.457 0.4-0.514 0.771-0.363 0.208-0.473 0.67-0.857 0.857-0.212 0.361-0.623
            0.521-0.773 0.943-0.191-0.037-0.034-0.422-0.085-0.599-0.219-0.066-0.394-0.126-0.514
            0.086-0.222-0.146 0.166-0.399 0.086-0.686
            0-0.228-0.239-0.219-0.343-0.343-0.075-0.126-0.128-0.271-0.343-0.257
            0.386-0.499 0.871-0.901 1.372-1.286 0.412-0.445 1.030-0.684 1.457-1.115
            1.369-0.346 2.262-1.167 4.030-1.114 0.313 0.058 0.623 0.119 1.028 0.085
            0.762 0.382 1.643 0.643 2.229 1.201 0.794 0.321 1.17 1.058 1.886 1.457
            0.112 0.374 0.489 0.483 0.601 0.857 0.222 0.235 0.365 0.549 0.6 0.771
            0.047 0.153 0.044 0.356 0.172 0.429 0.004 0.539 0.083 1.004 0.172 1.457v1.201h-0.001zM19.838
            5.638c-0.018-0.257-0.356 0.082 0 0v0zM19.838 5.638c-0.016 0.073 0.033
            0.081 0.085 0.086 0.015-0.073-0.033-0.081-0.085-0.086zM19.923 5.724c0.054
            0.125 0.104-0.008 0 0v0zM15.723 24.757c-0.26 0.054-0.738-0.11-0.857
            0.085-0.559-0.045-0.976 0.053-1.372 0.171-0.343 0.257-0.63 0.571-0.858
            0.943-0.183 0.789-0.004 1.787 0.086 2.572 0.115 0.057 0.159 0.183 0.171
             0.343 0.277 0.205 0.521 0.409 0.772 0.514 0.638 0.265 1.328 0.143 2.143
             0.171 0.146-0.197 0.573-0.113 0.686-0.342 0.325-0.019 0.417-0.27 0.686-0.343
             0.297-0.389 0.69-0.682 0.858-1.2 0.161-0.464 0.042-0.961 0-1.458-0.458-0.8-1.221-1.296-2.315-1.458zM15.723
             28.1c-0.41-0.032-0.862 0.232-1.2 0 0.081-0.375 0.090-0.825 0.171-1.201 0.193-0.208 0.344-0.457
             0.601-0.6 0.65-0.050 1.146 0.055 1.458 0.343 0.132 0.963-0.61 1.047-1.029 1.458z`}
        />
    </SvgIcon>
)

MissingIcon.defaultProps = defaultProps

export { MissingIcon }
